/**
 * Notification module
 */

import actions from './actions';
import menus from './menus';
import controller from './controller';
import {RegisterLegacyAction} from '@netx/core/legacyActionManager';
import {addMenus} from '@netx/core/legacyMenuManager';

/**
 * @property {object}   exports             - Our module exports
 * @property {string}   exports.namespace   - Module namespace
 * @property {function} exports.initialize  - Module initializer
 */
export default {
	namespace: 'notification',
	initialize() {
		// Register actions
		RegisterLegacyAction(actions);
		// Extend menus
		addMenus(menus);

		return controller.initialize();
	},
};
